/*
 * PanamaJack — Cart max-quantity + savings + mobile floating checkout (pj-cart-maxqty.js)
 * --------------------------------------------------------------------------------------
 * Re-implementa, iso-funcional, el <script> inline del main-cart 6.0.0 sobre el stack
 * 10.2.0 (web component nativo <cart-form> con AJAX merge-list). NO reimplementa el motor
 * de fetch de cantidades: el vendor <cart-form> ya intercepta .quantity-up / .quantity-down /
 * .cart-item__remove (delegados) y emite `theme:cartchanged` en `document` tras cada cambio.
 *
 * Aporta 4 features de PJ sobre ese stack:
 *   (a) TOPE DE PEDIDO = MAX 4 ítems. Si el carrito ya tiene >=4 (o el submit superaría 4),
 *       BLOQUEA el checkout y muestra un mensaje i18n en #cart-status-message. La intercepción
 *       del submit se hace en FASE DE CAPTURA (el vendor podría registrar su propio listener),
 *       y además se vigila el clic del botón "plus" que Liquid ya deshabilita vía can_increase.
 *   (b) Barra flotante de checkout en móvil (#floatingCheckoutBar / #floatingCheckoutBtn) que
 *       aparece cuando el botón real .checkout-btn queda por debajo del viewport.
 *   (c) Línea de ahorro total en #cart-savings (label desde data-savings-label, i18n
 *       cart.general.savings) calculada con compare_at_price vs price por variante.
 *   (d) Cantidad: respeta el tope; la lógica de incremento/AJAX la conduce el <cart-form>
 *       vendor. Tras cada `theme:cartchanged` (re-render merge-list) se RE-EVALÚA todo
 *       (idempotente) porque el DOM de la lista se reemplaza; MutationObserver de respaldo.
 *
 * Dependencias: opcionalmente jQuery (window.theme.jQuery / window.jQuery) — no es imprescindible;
 * todo el módulo es vanilla. Globales currentLanguageISO (layout/theme.liquid L110) usada para i18n
 * con fallback a <html lang>.
 *
 * FASE C: este archivo se cablea desde layout/theme.liquid con <script defer>.
 * El tope de 4 también corre fuera del carrito: bloquea el alta desde la ficha
 * (y el botón de pago rápido) y el enlace "Finalizar compra" del aviso de añadido,
 * que va directo a checkout sin pasar por el formulario del carrito.
 */
(function () {
  'use strict';

  var MAX_CART_ITEMS = 4;

  // ---- i18n ---------------------------------------------------------------
  // Mensaje de tope por pedido (mapa propio, iso-funcional con el 6.0.0). El idioma sale de
  // la global currentLanguageISO (definida en theme.liquid); fallback al atributo lang del <html>.
  var lang = (function () {
    var iso = (typeof window.currentLanguageISO === 'string' && window.currentLanguageISO) ||
      (document.documentElement.getAttribute('lang') || 'es');
    return iso.toLowerCase().split('-')[0];
  })();

  var MESSAGES = {
    generic: {
      es: 'No se ha podido actualizar el carrito. Inténtalo de nuevo.',
      en: 'The cart could not be updated. Please try again.',
      de: 'Der Warenkorb konnte nicht aktualisiert werden. Bitte erneut versuchen.',
      nl: 'De winkelwagen kon niet worden bijgewerkt. Probeer het opnieuw.',
      fr: 'Le panier n’a pas pu être mis à jour. Réessayez.',
      it: 'Impossibile aggiornare il carrello. Riprova.',
      pt: 'Não foi possível atualizar o carrinho. Tente novamente.',
      da: 'Kurven kunne ikke opdateres. Prøv igen.'
    },
    maxItems: {
      es: 'Solo se permiten hasta {n} artículos por pedido. Elimina algún producto antes de continuar.',
      en: 'A maximum of {n} items per order is allowed. Please remove some products before continuing.',
      de: 'Maximal {n} Artikel pro Bestellung. Bitte entfernen Sie einige Produkte, bevor Sie fortfahren.',
      nl: 'Maximaal {n} artikelen per bestelling. Verwijder enkele producten voordat u verdergaat.',
      fr: 'Maximum {n} articles par commande. Supprimez des produits avant de continuer.',
      it: 'Massimo {n} articoli per ordine. Rimuovi qualche prodotto prima di continuare.',
      pt: 'Máximo de {n} itens por pedido. Remova alguns produtos antes de continuar.',
      da: 'Maksimalt {n} varer pr. ordre. Fjern nogle produkter, før du fortsætter.'
    }
  };

  function t(key) {
    var group = MESSAGES[key] || {};
    return group[lang] || group.en || group.es || '';
  }

  // Decodifica las entidades HTML comunes de un texto de traducción (p.ej. &#39; -> ').
  // Se usa para etiquetas leídas de atributos {{ ... | t | escape }} que pueden venir
  // doble-escapadas. Ampersand al final para no re-decodificar de más.
  function decodeBasicEntities(str) {
    if (typeof str !== 'string' || str.indexOf('&') === -1) return str;
    return str
      .replace(/&#0*39;|&apos;/g, "'")
      .replace(/&#0*34;|&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&');
  }

  // ---- estado / utilidades ------------------------------------------------
  var currentItemCount = 0;
  var savingsToken = 0; // invalida cálculos de ahorro en vuelo cuando el carrito cambia

  function statusEl() {
    return document.getElementById('cart-status-message');
  }

  function showStatus(msg) {
    var el = statusEl();
    if (!el || !msg) return;
    el.textContent = msg;
    el.style.display = 'block';
    clearTimeout(el._pjHideTimer);
    el._pjHideTimer = setTimeout(function () {
      el.style.display = 'none';
    }, 6000);
  }

  function showMaxItemsMessage() {
    var msg = t('maxItems').replace('{n}', MAX_CART_ITEMS);
    showStatus(msg);
    var el = statusEl();
    if (el && typeof el.scrollIntoView === 'function') {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // Suma lo que realmente enviaría el formulario (inputs name="updates[]").
  // Protege frente a manipulaciones del DOM vía el inspector del navegador.
  function getPendingItemCount() {
    var form = document.getElementById('cartform');
    if (!form) return currentItemCount;
    var sum = 0;
    var qtyInputs = form.querySelectorAll('input[name="updates[]"]');
    for (var i = 0; i < qtyInputs.length; i++) {
      var v = parseInt(qtyInputs[i].value, 10);
      if (!isNaN(v) && v > 0) sum += v;
    }
    return sum;
  }

  function refreshServerCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart && typeof cart.item_count === 'number') {
          currentItemCount = cart.item_count;
        }
        return currentItemCount;
      })
      .catch(function () { return currentItemCount; });
  }

  // ---- (a) bloqueo de checkout por tope de pedido -------------------------
  // Bandera para permitir el submit "real" una vez validado (evita bucle con el re-disparo).
  var allowCheckoutSubmit = false;

  function attemptCheckout(submitFn) {
    var pending = getPendingItemCount();

    // Doble verificación contra el servidor por si updates[] fuese manipulado para enviar menos.
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var serverCount = (cart && typeof cart.item_count === 'number') ? cart.item_count : currentItemCount;
        currentItemCount = serverCount;
        var effective = Math.max(pending, serverCount);
        if (effective > MAX_CART_ITEMS) {
          showMaxItemsMessage();
          return false;
        }
        allowCheckoutSubmit = true;
        submitFn();
        return true;
      })
      .catch(function () {
        var effective = Math.max(pending, currentItemCount);
        if (effective > MAX_CART_ITEMS) {
          showMaxItemsMessage();
          return false;
        }
        allowCheckoutSubmit = true;
        submitFn();
        return true;
      });
  }

  function submitViaForm() {
    var form = document.getElementById('cartform');
    var checkoutBtn = document.querySelector('.checkout-btn');
    if (form && typeof form.requestSubmit === 'function' && checkoutBtn) {
      form.requestSubmit(checkoutBtn);
    } else if (checkoutBtn) {
      checkoutBtn.click();
    } else if (form) {
      form.submit();
    }
  }

  function isCheckoutSubmitter(node) {
    if (!node) return false;
    // El botón de checkout real, o el clon de la barra flotante.
    return (node.name === 'checkout') ||
      node.classList && (node.classList.contains('checkout-btn') || node.classList.contains('floating-checkout-btn'));
  }

  function bindCheckoutGuard() {
    var form = document.getElementById('cartform');
    if (!form || form._pjMaxqtyBound) return;
    form._pjMaxqtyBound = true;

    // Captura: corre antes que cualquier listener del vendor / atributos del form.
    form.addEventListener('submit', function (e) {
      if (allowCheckoutSubmit) {
        // submit ya validado por nosotros: dejarlo pasar y rearmar la bandera.
        allowCheckoutSubmit = false;
        return;
      }
      var submitter = e.submitter || document.activeElement;
      // El submit de "update" (name="update") no es checkout → no lo bloqueamos.
      if (submitter && submitter.name === 'update') return;

      // Cualquier otro submit del form de carrito lo tratamos como intento de checkout.
      e.preventDefault();
      e.stopImmediatePropagation();
      attemptCheckout(submitViaForm);
    }, true);
  }

  // ---- (b) barra flotante de checkout (móvil) -----------------------------
  function bindFloatingBar() {
    var floatingBar = document.getElementById('floatingCheckoutBar');
    var floatingBtn = document.getElementById('floatingCheckoutBtn');
    var realBtn = document.querySelector('.checkout-btn');
    if (!floatingBar || !floatingBtn || !realBtn) return;
    if (floatingBar._pjBound) return;
    floatingBar._pjBound = true;

    var mql = window.matchMedia('(max-width: 767px)');

    function isBtnBelowViewport() {
      var rect = realBtn.getBoundingClientRect();
      return rect.top >= window.innerHeight;
    }

    function updateFloating() {
      if (!mql.matches) {
        floatingBar.classList.remove('is-visible');
        return;
      }
      if (isBtnBelowViewport()) {
        floatingBar.classList.add('is-visible');
      } else {
        floatingBar.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', updateFloating, { passive: true });
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', updateFloating);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(updateFloating); // Safari antiguo
    }
    updateFloating();

    floatingBtn.addEventListener('click', function () {
      // Reusa el flujo de validación de tope vía el botón real.
      realBtn.click();
    });
  }

  // ---- (c) línea de ahorro total ------------------------------------------
  function renderSavings() {
    var savingsEl = document.getElementById('cart-savings');
    if (!savingsEl) return;

    var token = ++savingsToken; // anula cálculos previos que aún estén en vuelo
    // Oculta mientras recalcula para no dejar un valor obsoleto.
    savingsEl.style.display = 'none';

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (token !== savingsToken) return; // carrito cambió de nuevo: descartar
        if (!cart || !cart.items || !cart.items.length) return;

        var handles = [];
        cart.items.forEach(function (item) {
          if (item.handle && handles.indexOf(item.handle) === -1) handles.push(item.handle);
        });

        var productPromises = handles.map(function (handle) {
          return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); });
        });

        return Promise.all(productPromises).then(function (products) {
          if (token !== savingsToken) return;

          var variantMap = {};
          products.forEach(function (p) {
            if (p && p.variants) {
              p.variants.forEach(function (v) { variantMap[v.id] = v; });
            }
          });

          var totalSavings = 0;
          cart.items.forEach(function (item) {
            var variant = variantMap[item.variant_id];
            if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
              totalSavings += (variant.compare_at_price - variant.price) * item.quantity;
            }
          });

          if (totalSavings <= 0) {
            savingsEl.style.display = 'none';
            return;
          }

          var savingsInEur = totalSavings / 100;
          var formatted = savingsInEur
            .toFixed(2)
            .replace('.', ',')
            .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          var label = savingsEl.getAttribute('data-savings-label') || "You're saving:";
          // El atributo sale de {{ ... | t | escape }}. Si la traducción activa trae entidades
          // HTML (p.ej. &#39; por el apóstrofo, como las guardan las traducciones de admin),
          // | escape las re-escapa (doble-escape) y getAttribute devuelve el literal "&#39;".
          // El 6.0.0 usaba innerHTML (las decodificaba); aquí decodificamos las entidades HTML
          // comunes de forma explícita y mantenemos textContent (sin innerHTML → sin vector XSS).
          label = decodeBasicEntities(label);
          savingsEl.textContent = label + ' ' + formatted + '€';
          savingsEl.style.display = 'block';
        });
      })
      .catch(function () {/* silencioso: el ahorro es informativo */});
  }

  // ---- (d) guard del botón "plus" (tope visual + mensaje) -----------------
  // El vendor <cart-form> conduce el AJAX de cantidades vía delegación sobre .quantity-up /
  // .quantity-down. Liquid ya deshabilita el "plus" (pointer-events:none) cuando cart>=4 o se
  // alcanza el inventario. Aquí solo añadimos el aviso i18n si el usuario insiste en el tope.
  // El + se pinta apagado en Liquid cuando el pedido ya tiene 4 unidades. El merge del
  // carrito reutiliza la fila si esa línea no cambió, así que al borrar otro artículo el +
  // seguía apagado hasta recargar. Aquí se vuelve a abrir en cuanto el total baja de 4.
  // data-pj-plus-block="stock" no se toca: ese tope es de inventario, no del pedido.
  // La cantidad de los inputs va por delante del servidor: varios clics seguidos suman
  // en pantalla antes de que /cart.js responda. Si solo miráramos el servidor, un
  // recuento viejo volvería a encender el + y se colarían unidades de más.
  function cappedCount(serverCount) {
    var pending = getPendingItemCount();
    if (typeof serverCount !== 'number') return pending;
    return Math.max(serverCount, pending);
  }

  function syncPlusButtons(count) {
    var form = document.getElementById('cartform');
    if (!form || typeof count !== 'number') return;
    var atCap = cappedCount(count) >= MAX_CART_ITEMS;
    var pluses = form.querySelectorAll('.quantity-up');
    for (var i = 0; i < pluses.length; i++) {
      var plus = pluses[i];
      if (plus.getAttribute('data-pj-plus-block') === 'stock') continue;
      if (atCap) {
        if (plus.getAttribute('href') && plus.getAttribute('href') !== '#') {
          plus.setAttribute('data-pj-plus-href', plus.getAttribute('href'));
        }
        plus.setAttribute('href', '#');
        plus.style.pointerEvents = 'none';
        plus.style.opacity = '0.5';
        plus.setAttribute('data-pj-plus-block', 'order');
      } else if (plus.getAttribute('data-pj-plus-block') === 'order') {
        var href = plus.getAttribute('data-pj-plus-href');
        if (href && href !== '#') plus.setAttribute('href', href);
        plus.style.pointerEvents = '';
        plus.style.opacity = '';
        plus.removeAttribute('data-pj-plus-block');
      }
    }
  }

  function bindQtyGuard() {
    var form = document.getElementById('cartform');
    if (!form || form._pjQtyGuardBound) return;
    form._pjQtyGuardBound = true;

    // Captura, antes de que el tema sume 1 al input. Si lo que ya se ve llega al tope,
    // el clic no entra: así no da tiempo a pasar de 4 por pulsar rápido.
    form.addEventListener('click', function (e) {
      var plus = e.target.closest && e.target.closest('.js-qty-plus, .quantity-up');
      if (!plus) return;
      if (plus.getAttribute('data-pj-plus-block') === 'stock') return;
      if (getPendingItemCount() < MAX_CART_ITEMS) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showMaxItemsMessage();
      syncPlusButtons(getPendingItemCount());
    }, true);
  }

  // ---- tope fuera del carrito (ficha + aviso "Finalizar compra") ----------
  function addedQuantity(form) {
    var input = form && form.querySelector('[name="quantity"]');
    var qty = input ? parseInt(input.value, 10) : 1;
    return !qty || qty < 1 ? 1 : qty;
  }

  function showLimitMessage(origin, msg) {
    var modal = origin && origin.closest && origin.closest('#added-to-cart');
    if (!modal) modal = document.getElementById('added-to-cart');
    var host = modal || (origin && origin.closest && origin.closest('form')) || origin;
    if (!host) return;
    var note = host.querySelector('.pj-max-items-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'pj-max-items-note';
      note.setAttribute('role', 'status');
      var links = host.querySelector('.links');
      var err = host.querySelector('.error-message, .product-status-message');
      if (links && links.parentNode) links.parentNode.insertBefore(note, links);
      else if (err && err.parentNode) err.parentNode.insertBefore(note, err);
      else host.insertBefore(note, host.firstChild);
    }
    note.textContent = msg;
  }

  function bindProductAddGuard() {
    if (document.documentElement._pjAddGuard) return;
    document.documentElement._pjAddGuard = true;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.nodeName !== 'FORM') return;
      var action = (form.getAttribute('action') || '') + ' ' + (form.action || '');
      if (action.indexOf('/cart/add') === -1) return;
      if (form._pjAllowAdd) {
        form._pjAllowAdd = false;
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      if (form._pjAddPending) return;
      form._pjAddPending = true;
      var qty = addedQuantity(form);
      var submitter = e.submitter;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          form._pjAddPending = false;
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : currentItemCount;
          currentItemCount = count;
          if (count + qty > MAX_CART_ITEMS) {
            showLimitMessage(form, t('maxItems').replace('{n}', MAX_CART_ITEMS));
            return;
          }
          currentItemCount = count + qty;
          form._pjAllowAdd = true;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
          else form.submit();
        })
        .catch(function () {
          form._pjAddPending = false;
          form._pjAllowAdd = true;
          if (typeof form.requestSubmit === 'function') form.requestSubmit(submitter || undefined);
          else form.submit();
        });
    }, true);

    // Pago rápido: el clic tiene que seguir siendo el del usuario. Solo lo cortamos
    // cuando el recuento que ya tenemos supera el tope; si cabe, no se toca.
    document.addEventListener('click', function (e) {
      var pay = e.target.closest && e.target.closest('.shopify-payment-button, shopify-accelerated-checkout');
      if (!pay) return;
      var form = pay.closest('form');
      var qty = addedQuantity(form);
      if (currentItemCount + qty <= MAX_CART_ITEMS) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      showLimitMessage(form || pay, t('maxItems').replace('{n}', MAX_CART_ITEMS));
    }, true);
  }

  function bindCheckoutLinkGuard() {
    if (document.documentElement._pjCheckoutLinkGuard) return;
    document.documentElement._pjCheckoutLinkGuard = true;

    document.addEventListener('click', function (e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link) return;
      var href = link.getAttribute('href') || '';
      if (href.indexOf('/checkout') === -1) return;
      if (link._pjCheckoutPending) {
        e.preventDefault();
        return;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      link._pjCheckoutPending = true;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          link._pjCheckoutPending = false;
          var count = cart && typeof cart.item_count === 'number' ? cart.item_count : currentItemCount;
          currentItemCount = count;
          if (count > MAX_CART_ITEMS) {
            showLimitMessage(link, t('maxItems').replace('{n}', MAX_CART_ITEMS));
            return;
          }
          window.location.href = link.href;
        })
        .catch(function () {
          link._pjCheckoutPending = false;
          window.location.href = link.href;
        });
    }, true);
  }

  // ---- orquestación + idempotencia ----------------------------------------
  function init() {
    // Inicializa el conteo desde data (si lo hubiera) y refresca con el servidor.
    var form = document.getElementById('cartform');
    if (!form && !document.getElementById('cart-savings')) return; // página sin carrito → inerte

    refreshServerCount().then(syncPlusButtons);
    bindCheckoutGuard();
    bindQtyGuard();
    bindFloatingBar();
    renderSavings();
  }

  function reEvaluate() {
    // Tras un re-render del merge-list los nodos cambian: re-vincula (idempotente) y recalcula.
    refreshServerCount().then(syncPlusButtons);
    bindCheckoutGuard();
    bindQtyGuard();
    bindFloatingBar();
    renderSavings();
  }

  // El vendor <cart-form> 10.2.0 emite `theme:cartchanged` en document tras cada cambio AJAX.
  document.addEventListener('theme:cartchanged', function () {
    // Espera al re-render (merge-list) y luego re-evalúa.
    setTimeout(reEvaluate, 0);
  });

  // Respaldo: si el merge-list reemplaza nodos sin un evento que captemos, un observer ligero
  // re-vincula los handlers (todas las funciones bind* son idempotentes).
  function attachObserver() {
    var cartForm = document.querySelector('cart-form');
    if (!cartForm || typeof MutationObserver === 'undefined') return;
    var pending = false;
    var syncTimer = null;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        bindFloatingBar();
        bindCheckoutGuard();
        bindQtyGuard();
        clearTimeout(syncTimer);
        syncTimer = setTimeout(function () {
          refreshServerCount().then(syncPlusButtons);
        }, 60);
      });
    });
    observer.observe(cartForm, { childList: true, subtree: true });
  }

  function boot() {
    bindProductAddGuard();
    bindCheckoutLinkGuard();
    refreshServerCount();
    init();
    attachObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
